import React from 'react';
import { useTranslation } from 'react-i18next';

import { normalizeWebsiteUrl } from '@mssgme/helpers';
import { TextField, ToggleField } from '@mssgme/ui';
import { FieldTip } from '@mssgme/app/components/UI';
import CardEditForm from '../CardEditForm';

export default function WebsiteEdit() {
    const { t } = useTranslation('cards');

    return (
        <CardEditForm title={t('WebsiteEdit.title')}>
            {() => (
                <>
                    <ToggleField
                        label={t('WebsiteEdit.labels.enabled')}
                        name="profile.website.enabled"
                        restrictRule="website:edit"
                        style={{ marginBottom: '20px' }}
                    />
                    <div style={{ height: 1, backgroundColor: 'rgba(0,0,0,.1)', margin: '-12px 0 14px 0' }} />
                    <TextField
                        label={t('WebsiteEdit.labels.linkTitle')}
                        style={{ marginBottom: '10px' }}
                        name="profile.website.title"
                        placeholder={t('profileEdit.placeholder.default_website_title')}
                        maxLength={100}
                    />
                    <TextField
                        label={t('WebsiteEdit.labels.linkUrl')}
                        name="profile.website.url"
                        placeholder={t('profileEdit.placeholder.website')}
                        maxLength={255}
                        mask={normalizeWebsiteUrl}
                    />
                    <FieldTip>{t('FieldTip.website')}</FieldTip>
                </>
            )}
        </CardEditForm>
    );
}
